import React, { useEffect, useState } from "react";
import {
  Box,
  Collapse,
  SpeedDial,
  SpeedDialAction,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import useStyles from "./styles";
import LayersIcon from "@mui/icons-material/Layers";
import { MultipleStop, SignalCellularAlt } from "@mui/icons-material";
import { useOutletContext } from "react-router-dom";

const LayerBar = ({
  mapId = null,
  elementSelected = null,
  editMode = false,
  collapse,
}) => {
  const theme = useTheme();
  const { configLayer, setConfigLayer, config } = useOutletContext();
  const styles = useStyles(
    theme,
    elementSelected,
    configLayer?.[mapId],
    collapse
  );

  const [visibleLayer, setVisibleLayer] = useState(configLayer?.[mapId]);
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    if (configLayer?.[mapId] !== visibleLayer) {
      setCollapsed(false);
      const timer = setTimeout(() => {
        setVisibleLayer(configLayer?.[mapId]);
        setCollapsed(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [configLayer?.[mapId], visibleLayer]);

  const handleChange = (layer) => {
    setConfigLayer((data) => {
      if (data?.[mapId]) {
        data[mapId] = layer;
      } else {
        data = { ...data, [mapId]: layer };
      }
      return { ...data };
    });
  };

  const handleFabClick = (e) => {
    e.stopPropagation();
  };

  return (
    <Stack sx={styles.container}>
      <SpeedDial
        sx={{
          "& .MuiSpeedDial-fab": {
            backgroundColor: theme.palette.layers?.[configLayer?.[mapId]],
            transition: "background-color 0s linear .5s !important",
          },
        }}
        ariaLabel="LayerBar"
        icon={
          <span
            onClick={handleFabClick}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LayersIcon />
          </span>
        }
      >
        <SpeedDialAction
          key="potencia"
          icon={
            <SignalCellularAlt sx={{ color: theme.palette.layers?.potencia }} />
          }
          tooltipTitle="Potência"
          tooltipOpen={true}
          tooltipPlacement="right"
          onClick={() => handleChange("potencia")}
        />
        <SpeedDialAction
          key="trafego"
          icon={<MultipleStop sx={{ color: theme.palette.layers?.trafego }} />}
          tooltipTitle="Tráfego"
          tooltipOpen={true}
          tooltipPlacement="right"
          onClick={() => handleChange("trafego")}
        />
      </SpeedDial>

      <Box sx={styles.textLayer}>
        <Collapse
          in={collapsed}
          orientation="horizontal"
          timeout={500}
          unmountOnExit
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Box
            display="flex"
            alignItems="center"
            sx={{
              justifyContent: "flex-end",
              width: 160,
              overflow: "hidden",
              minWidth: 0,
            }}
          >
            {visibleLayer === "potencia" && (
              <>
                <SignalCellularAlt />
                <Typography>Mapa de Potência</Typography>
              </>
            )}
            {visibleLayer === "trafego" && (
              <>
                <MultipleStop />
                <Typography>Mapa de Tráfego</Typography>
              </>
            )}
          </Box>
        </Collapse>
      </Box>
    </Stack>
  );
};

export default LayerBar;
